import { ProfileInfoFieldType } from '../../../Widget'
import {
  USER_PROFILE_INFO_DEPOSIT_TYPE_FIELD_NAME,
  USER_PROFILE_INFO_FUNDINGS_FIELD_NAME,
  USER_PROFILE_INFO_GUARANTEED_VALUE_FIELD_NAME,
  USER_PROFILE_INFO_REMEDY_FIELD_NAME,
  USER_PROFILE_INFO_STOP_OVERDUE_NOTICE_FIELD_NAME,
  USER_PROFILE_INFO_TERMINATION_DENIED_FIELD_NAME,
  USER_PROFILE_INFO_TERMINATION_TIME_FIELD_NAME,
  USER_PROFILE_INFO_TERMINATION_TIMEFRAME_FIELD_NAME,
} from '../UserProfileWidget.constants'

export const ORAG_CLUSTER_FIELDS = [
  {
    labelKey: 'Widget.InfoDepositTypeLabelKey',
    maxLength: 256,
    name: USER_PROFILE_INFO_DEPOSIT_TYPE_FIELD_NAME,
    placeholderKey: 'Widget.InfoDepositTypePlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    labelKey: 'Widget.InfoFundingsLabelKey',
    maxLength: 256,
    name: USER_PROFILE_INFO_FUNDINGS_FIELD_NAME,
    placeholderKey: 'Widget.InfoFundingsPlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    labelKey: 'Widget.InfoGuaranteedValueLabelKey',
    maxLength: 256,
    name: USER_PROFILE_INFO_GUARANTEED_VALUE_FIELD_NAME,
    placeholderKey: 'Widget.InfoGuaranteedValuePlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    labelKey: 'Widget.InfoTerminationTimeLabelKey',
    maxLength: 256,
    name: USER_PROFILE_INFO_TERMINATION_TIME_FIELD_NAME,
    placeholderKey: 'Widget.InfoTerminationTimePlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    labelKey: 'Widget.InfoTerminationDeniedLabelKey',
    maxLength: 256,
    name: USER_PROFILE_INFO_TERMINATION_DENIED_FIELD_NAME,
    placeholderKey: 'Widget.InfoTerminationDeniedPlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    labelKey: 'Widget.InfoTerminationTimeframeLabelKey',
    maxLength: 256,
    name: USER_PROFILE_INFO_TERMINATION_TIMEFRAME_FIELD_NAME,
    placeholderKey: 'Widget.InfoTerminationTimeframePlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    labelKey: 'Widget.InfoStopOverdueNoticeLabelKey',
    maxLength: 256,
    name: USER_PROFILE_INFO_STOP_OVERDUE_NOTICE_FIELD_NAME,
    placeholderKey: 'Widget.InfoStopOverdueNoticePlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
  {
    labelKey: 'Widget.InfoRemedyLabelKey',
    maxLength: 256,
    name: USER_PROFILE_INFO_REMEDY_FIELD_NAME,
    placeholderKey: 'Widget.InfoRemedyPlaceholderKey',
    type: ProfileInfoFieldType.TEXT,
  },
]
